<template>
  <div class="mt-3 mb-3">
    <div
      v-for="(day, dayIndex) in availabilityPerSlot"
      :key="dayIndex"
      class="Availability-table-container is-flex mt-2"
    >
      <div v-if="day.length">
        <p class="hb-fonts-body-regular has-text-weight-bold">
          {{ dayIndex ? secondDayDate : firstDayDate }}
        </p>
        <p
          v-for="(time, timeIndex) in day"
          :key="timeIndex"
          class="hb-fonts-body-regular has-text-weight-light pl-4"
        >
          <span v-if="timeIndex < day.length - 1">
            {{ time[0] }}:00 - {{ day[timeIndex + 1][0] }}:00
          </span>
        </p>
      </div>
      <div v-if="day.length">
        <p class="hb-fonts-body-regular has-text-weight-bold has-text-centered">
          Freie Termine
        </p>
        <p
          v-for="(time, timeIndex) in day"
          :key="timeIndex"
          class="hb-fonts-body-regular has-text-weight-light has-text-centered"
        >
          <span v-if="timeIndex < day.length - 1">{{ time[1] }}</span>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AvailabilityTable',

  props: {
    availabilityPerSlot: {
      type: Array,
      required: true
    },
    firstDayDate: {
      type: String,
      required: true
    },
    secondDayDate: {
      type: String,
      required: false
    }
  }
}
</script>

<style lang="scss" scoped>
.Availability-table-container {
  justify-content: space-between;
  max-width: 420px;
}
</style>
